export default "__VITE_ASSET__2Z8Q8Owr__"